// directives/price-format.ts
import { usePriceFormatter } from "@/composables/usePriceFormatter"
import type { Directive } from "vue"

export const vPriceFormat: Directive<
  HTMLElement,
  number | { value: number; precision?: number }
> = {
  mounted(el, binding) {
    const { formatPrice } = usePriceFormatter()

    const value =
      typeof binding.value === "object" ? binding.value.value : binding.value
    const precision =
      typeof binding.value === "object" ? binding.value.precision ?? 1 : 1

    el.textContent = formatPrice(value, precision)
  },

  updated(el, binding) {
    const { formatPrice } = usePriceFormatter()

    const value =
      typeof binding.value === "object" ? binding.value.value : binding.value
    const precision =
      typeof binding.value === "object" ? binding.value.precision ?? 1 : 1

    el.textContent = formatPrice(value, precision)
  },
}
